module.exports = __webpack_public_path__ + "static/media/square.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Tekentool/assets/alternate/square.svg
// module id = 59
// module chunks = 0